import {
  GET_ORDER_DETAIL_LIST_REQUEST,
  GET_ORDER_DETAIL_LIST_RESPONSE,
  GET_ORDER_DETAIL_WITH_LINES_BY_ORDER_ID_REQUEST,
  GET_ORDER_DETAIL_WITH_LINES_BY_ORDER_ID_RESPONSE,
  SET_ORDER_STATUS_REQUEST,
  SET_ORDER_STATUS_RESPONSE,
} from "./actionTypes";

export const getOrderDetailListRequest = (filter) => {
  return {
    type: GET_ORDER_DETAIL_LIST_REQUEST,
    payload: { filter },
  };
};

export const getOrderDetailListResponse = (apiResponse) => {
  return {
    type: GET_ORDER_DETAIL_LIST_RESPONSE,
    payload: { apiResponse },
  };
};

export const getOrderDetailWithLinesByOrderIdRequest = (orderId, callback) => {
  return {
    type: GET_ORDER_DETAIL_WITH_LINES_BY_ORDER_ID_REQUEST,
    payload: { orderId },
    callback,
  };
};

export const getOrderDetailWithLinesByOrderIdResponse = (apiResponse) => {
  return {
    type: GET_ORDER_DETAIL_WITH_LINES_BY_ORDER_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const setOrderStatusRequest = (orderId, status) => {
  return {
    type: SET_ORDER_STATUS_REQUEST,
    payload: { orderId, status },
  };
};

export const setOrderStatusResponse = (apiResponse) => {
  return {
    type: SET_ORDER_STATUS_RESPONSE,
    payload: { apiResponse },
  };
};
